export enum WeekDaysEnum {
  Sunday = 0,
  Monday = 1,
  Tuesday = 2,
  Wednesday = 3,
  Thursday = 4,
  Friday = 5,
  Saturday = 6,
}

export const weeklyDays = Object.entries(WeekDaysEnum)
  .filter(([key, value]) => !isNaN(Number(value)))
  .map(([key, value]) => ({ id: value.toString(), title: key }));
